import React from 'react'
import { Ico } from '@/components/icons'
import { Sidebar, Topbar } from '@/components/AccountShell'
import { useLang } from '@/lib/lang'

const VisitHistory = () => {
  const { t } = useLang()
  const v = t.acct.manage.visits

  return (
    <div className="app-shell">
      <Sidebar active="visits"/>
      <div className="main-pane">
        <Topbar crumbs={[t.acct.nav.visits, "History"]}/>
        <div className="content">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "end", marginBottom: 20 }}>
            <div>
              <div className="kicker accent" style={{ marginBottom: 10 }}>◆ {v.since}</div>
              <h1 className="h-display" style={{ fontSize: 36, margin: 0 }}>
                {v.title_1} <span className="font-serif" style={{ color: "var(--terracotta)", fontWeight: 400 }}>{v.title_2}</span>
              </h1>
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button className="btn btn-ghost" style={{ padding: "10px 14px", fontSize: 12 }}><Ico.filter/> {v.year_filter}</button>
              <button className="btn btn-ghost" style={{ padding: "10px 14px", fontSize: 12 }}><Ico.filter/> {v.all_categories}</button>
              <button className="btn btn-ghost" style={{ padding: "10px 14px", fontSize: 12 }}><Ico.download/> {v.export_csv}</button>
            </div>
          </div>

          {/* Stats strip */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10, marginBottom: 18 }}>
            {[
              { k: v.total_visits, val: "47" },
              { k: v.hrs_work, val: "62.4" },
              { k: v.photos_logged, val: "284" },
              { k: v.saved_vs_acart, val: "$2,140", accent: true },
            ].map(s => (
              <div key={s.k} className="tile tile-sm">
                <div className="font-mono" style={{ fontSize: 10, color: "var(--muted)" }}>{s.k}</div>
                <div className="h-display" style={{ fontSize: 26, marginTop: 4, color: s.accent ? "var(--terracotta)" : "var(--cocoa)" }}>{s.val}</div>
              </div>
            ))}
          </div>

          {/* Table */}
          <div className="tile" style={{ padding: 0, overflow: "hidden" }}>
            <div style={{ display: "grid", gridTemplateColumns: "auto 1fr 110px 130px 90px 80px 36px", padding: "12px 18px", borderBottom: "1px solid var(--line)", fontFamily: "'Geist Mono', monospace", fontSize: 10, color: "var(--muted)", letterSpacing: "0.08em" }}>
              <span style={{ width: 16 }}/>
              <span>{v.col_job}</span>
              <span>{v.col_date}</span>
              <span>{v.col_pro}</span>
              <span>{v.col_cost}</span>
              <span>{v.col_status}</span>
              <span/>
            </div>
            {v.history.map((visit, i) => {
              const isEmergency = visit.tags.some(tag =>
                tag === "EMERGENCY" || tag === "EMERGENCIA"
              )
              const cost = visit.cost_key ? v[visit.cost_key] : visit.cost
              return (
                <div key={visit.id} style={{ display: "grid", gridTemplateColumns: "auto 1fr 110px 130px 90px 80px 36px", padding: "16px 18px", borderTop: i > 0 ? "1px solid var(--line)" : "none", alignItems: "center", gap: 8 }}>
                  <div style={{ width: 4, height: 36, borderRadius: 2, background: visit.status === "upcoming" ? "var(--gold)" : isEmergency ? "var(--terracotta)" : "var(--sage)" }}/>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>{visit.title}</div>
                    <div style={{ display: "flex", gap: 6, marginTop: 4, alignItems: "center" }}>
                      <span className="font-mono" style={{ fontSize: 10, color: "var(--muted)" }}>{visit.id} · {visit.room_key}</span>
                      {visit.tags.map(tag => <span key={tag} style={{ fontFamily: "'Geist Mono', monospace", fontSize: 9, color: isEmergency ? "var(--terracotta-deep)" : "var(--muted)", padding: "1px 6px", borderRadius: 4, background: isEmergency ? "rgba(194,85,45,0.12)" : "var(--cream-2)" }}>{tag}</span>)}
                      {visit.photos && <span className="font-mono" style={{ fontSize: 10, color: "var(--terracotta)" }}>📷 {visit.photos}</span>}
                    </div>
                  </div>
                  <span className="font-mono" style={{ fontSize: 12 }}>{visit.date}</span>
                  <div>
                    <div style={{ fontSize: 13 }}>{visit.pro}</div>
                    <div className="font-mono" style={{ fontSize: 10, color: "var(--muted)" }}>{visit.duration}</div>
                  </div>
                  <span className="font-mono" style={{ fontSize: 13, color: visit.cost_key === "included" ? "var(--sage)" : "var(--cocoa)", fontWeight: 600 }}>{cost}</span>
                  <span className={`status-pill ${visit.status === "upcoming" ? "pill-upcoming" : "pill-done"}`} style={{ padding: "2px 7px" }}>
                    <span className="dot"/>{visit.status === "upcoming" ? v.upcoming : v.done}
                  </span>
                  <Ico.chev style={{ color: "var(--muted)" }}/>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default function ManageVisitsPage() {
  return <VisitHistory />
}
